import React from "react";
import "./footer.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import india from '../../img/ind.svg';
import uk from '../../img/uk.svg';
import uae from '../../img/uae.svg';
import canada from '../../img/canada.svg';
import ireland from '../../img/ireland.svg';
import playStore from '../../img/playStore.svg';
import appStore from '../../img/appStore.svg';
import master from '../../img/master.svg';
import visa from '../../img/visa.svg';
import american from '../../img/american.svg';
import discover from '../../img/discover.svg';




const Footer = () => {
  const Navigate = useNavigate();
  const loc = useLocation();
  const handleScrollToSection = (e, section) => {
    e.preventDefault(); // Prevent default anchor behavior

    const ref =
      section === "howItWorks"
        ? window.section2Ref
        : "faqs"
          ? window.faqsRef
          : window.feedbackRef;
    if (ref && loc.pathname === "/") {
      ref.current.scrollIntoView({ behavior: "smooth" });
    } else {
      Navigate("/");
      setTimeout(() => {
        if (ref) {
          ref.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // Delay scrolling to allow the homepage to load
    }
  };
  return (
    <footer className="footer">
      <div className="flex justify-end gap-5 mb-4">
        <img src="/assets/privacy.svg" className="w-[96px]" alt="" />
        <img src="/assets/iso.svg" className="w-[92px]" alt="" />
      </div>

      <div className="flex flex-wrap md:justify-end gap-5 mb-4">
        <div class="relative inline-block text-left group">
          <button
            type="button"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent hover:border hover:border-gray-300 shadow-sm px-4 py-2 bg-[#B4B4B433] text-sm font-bold text-gray-700 hover:bg-gray-50"
          >
            <img src={india} className="me-2" alt="" />
            India
            <svg class="ml-2 -mr-1 h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            class="absolute hidden group-hover:block right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 left-0"
          >
            <div class="p-4">
              <p className="font-semibold"> Jaipur (Headquarter)</p>
              <p>70/38, Patel Marg, <br /> Mansarovar, Jaipur, <br /> India</p>
              <p className="font-semibold">Kota</p>
              <p>86/87-A, Shrinathpuram,<br /> Sector- A, Kota, <br /> India</p>
            </div>
          </div>
        </div>

        <div class="relative inline-block text-left group">
          <button
            type="button"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent hover:border hover:border-gray-300 shadow-sm px-4 py-2 bg-[#B4B4B433] text-sm font-bold text-gray-700 hover:bg-gray-50"
          >
            <img src={uk} className="me-2" alt="" />
            United Kingdom
            <svg class="ml-2 -mr-1 h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            class="absolute hidden group-hover:block right-0 left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          >
            <div class="p-4">
              <p className="font-semibold">United Kingdom Office</p>
              <p>123 Baker Street<br />London, UK<br />ZIP: W1U 6RT</p>
            </div>
          </div>
        </div>

        <div class="relative inline-block text-left group">
          <button
            type="button"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent hover:border hover:border-gray-300 shadow-sm px-4 py-2 bg-[#B4B4B433] text-sm font-bold text-gray-700 hover:bg-gray-50"
          >
            <img src={ireland} className="me-2" alt="" />
            Ireland
            <svg class="ml-2 -mr-1 h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            class="absolute hidden group-hover:block right-0 left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          >
            <div class="p-4">
              <p className="font-semibold">Ireland Office</p>
              <p>4 Curlew Road,<br />Dublin 12,<br />Ireland</p>
            </div>
          </div>
        </div>

        <div class="relative inline-block text-left group">
          <button
            type="button"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent hover:border hover:border-gray-300 shadow-sm px-4 py-2 bg-[#B4B4B433] text-sm font-bold text-gray-700 hover:bg-gray-50"
          >
            <img src={canada} className="me-2" alt="" />
            Canada
            <svg class="ml-2 -mr-1 h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            class="absolute hidden group-hover:block right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          >
            <div class="p-4">
              <p className="font-semibold">Canada Office</p>
              <p>2224 Speers Road, <br /> Oakville,  Ontario,<br />Canada</p>
            </div>
          </div>
        </div>

        <div class="relative inline-block text-left group">
          <button
            type="button"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent hover:border hover:border-gray-300 shadow-sm px-4 py-2 bg-[#B4B4B433] text-sm font-bold text-gray-700 hover:bg-gray-50"
          >
            <img src={uae} className="me-2" alt="" />
            United Arab Emirates
            <svg class="ml-2 -mr-1 h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            class="absolute hidden group-hover:block right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          >
            <div class="p-4">
              <p className="font-semibold">UAE Office</p>
              <p>OEM Enterprises LLC,<br />Sharjah,<br />UAE</p>
            </div>
          </div>
        </div>
      </div>


      <div className="footer-top">
        <div className="footer-column">
          <h4>Get to know us</h4>
          <ul>
            <li className="cursor-pointer">
              <Link to="/blogs" className="hover:text-[#65CBE4]">
                Blogs
              </Link>
            </li>

            {loc.pathname === "/" && (
              <li
                onClick={(e) => handleScrollToSection(e, "faqs")}
                className="cursor-pointer hover:text-[#65CBE4]"
              >
                Faqs
              </li>
            )}

            {loc.pathname === "/" && (
              <li
                onClick={(e) => handleScrollToSection(e, "howItWorks")}
                className="cursor-pointer hover:text-[#65CBE4]"
              >
                How It Works
              </li>
            )}

            {loc.pathname === "/" && (
              <li
                onClick={(e) => handleScrollToSection(e, "reviews")}
                className="cursor-pointer hover:text-[#65CBE4]"
              >
                Reviews
              </li>
            )}

            <li className="cursor-pointer">
              <Link to="/contact-us" className="hover:text-[#65CBE4]">
                Contact Us
              </Link>
            </li>

            <li className="cursor-pointer">
              <Link to="/plans" className="hover:text-[#65CBE4]">
                Our Offers
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Subjects</h4>
          <ul>
            <li className="links">
              <Link to="/services/finance-assignment">Finance Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/artificial-intelligence">Artificial Intelligence Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/autocad-assignment">Autocad Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/mba-assignment">MBA Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/r-assignment">R Assignment Assistance</Link>
            </li>
            <li className="links">
              <Link to="/services/accounting-assignment">Accounting Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/nursing-assignment">Nursing Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/accounting-problems-assignment">Accounting Problems Solver</Link>
            </li>
            <li className="links">
              <Link to="/services/cs-assignment">Computer Science Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/engineering-assignment">Engineering Assignment Help</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="invisible">Subjects</h4>
          <ul>

            <li className="links">
              <Link to="/services/law-assignment">Law Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/spss-assignment">SPSS Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/arcgis-assignment">ArcGIS Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/economics-assignment">Economics Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/stata-assignment-help">Stata Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/java-programming-assignment">Java Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/financial-accounting-assignment">Financial Accounting Assignment Help</Link>
            </li>
            <li className="links">
              <Link to="/services/c++-assignment">C++ Assignment Help</Link>
            </li>

          </ul>
        </div>
        <div className="footer-column">
          <h4>Essay</h4>
          <ul>

            <li className="links">
              <Link to="/services/persuasive-essay-writing">Persuasive Essay Writing</Link>
            </li>
            <li className="links">
              <Link to="/services/expository-essay-writing">Expository Essay Writing</Link>
            </li>
            <li className="links">
              <Link to="/services/descriptive-essay-writing">Descriptive Essay Writing</Link>
            </li>
            <li className="links">
              <Link to="/services/scholarship-essay-writing">Scholarship Essay Writing</Link>
            </li>
            <li className="links">
              <Link to="/services/order-essay-writing">Order An Essay</Link>
            </li>
            <li className="links">
              <Link to="/services/write-essay-for-money">Write Essay For Money</Link>
            </li>
            <li className="links">
              <Link to="/services/fast-essay-writing">Fast Essay Writing</Link>
            </li>
            <li className="links">
              <Link to="/services/pay-for-essay">Pay for Essay</Link>
            </li>
            <li className="links">
              <Link to="/services/essay-writers">Essay Writers</Link>
            </li>
            <li className="links">
              <Link to="/services/essays-for-sale">Essays for Sale</Link>
            </li>
            <li className="links">
              <Link to="/services/college-essay-writing-service">College Essay Writing Service</Link>
            </li>

          </ul>
        </div>
        <div className="footer-column">
          <h4>Citation Tools</h4>
          <ul>

            <li className="links">
              <Link to="/services/apa-citation" className="hover:text-[#65CBE4]">
                APA Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/chicago-citation" className="hover:text-[#65CBE4]">
                Chicago Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/harvard-citation" className="hover:text-[#65CBE4]">
                Harvard Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/mla-citation" className="hover:text-[#65CBE4]">
                MLA Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/vancouver-citation" className="hover:text-[#65CBE4]">
                Vancouver Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/oxford-citation" className="hover:text-[#65CBE4]">
                Oxford Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/swinburne-citation" className="hover:text-[#65CBE4]">
                Swinburne Citation
              </Link>
            </li>
            <li className="links">
              <Link to="/services/griffith-citation" className="hover:text-[#65CBE4]">
                Griffith Citation
              </Link>
            </li>

          </ul>
        </div>
      </div>
      <div className="footer-middle flex justify-between" style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#777',
      }}>
        <div className="mb-3">Contact us: +91-9352555548</div>
        <div className="text-center mb-3">
          <p className="text-center mb-1">
            App Coming soon
          </p>
          <div className="flex flex-wrap gap-4 justify-center ">
            <img src={playStore} alt="" />
            <img src={appStore} alt="" />

          </div>
        </div>
        <div className="">
          <p className="mb-1 md:text-right ">
            100% Secure Pay
          </p>
          <div className="flex flex-wrap gap-2">
            <img src={master} alt="" />
            <img src={visa} alt="" />
            <img src={american} alt="" />
            <img src={discover} alt="" />

          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Copyright © 2025 theassignmenthub.com. All rights reserved.</p>

        <p className="footer-links">
          <span className="text-gray-800">
            <Link to="/terms-and-conditions" className="hover:text-[#65CBE4]">
              Term of use
            </Link>
          </span>{" "}
          |{" "}
          <span className="text-gray-800">
            <Link to="/privacy-policy" className="hover:text-[#65CBE4]">
              Privacy policy
            </Link>
          </span>{" "}
          |{" "}
          <span className="text-gray-800">
            <Link to="/Refund-Policies" className="hover:text-[#65CBE4]">
              Revision & Refund policy
            </Link>
          </span>{""}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
